import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, VolunteerStatusId, VolunteerTopic } from '@interfaces';
import { VolunteerTopicsFormDialog, VolunteerTopicsFormDialogData } from '../../../..';
import { VolunteerDialogDataService } from '../../volunteer-dialog-data.service';

export function getActions(dialogDataService: VolunteerDialogDataService, dialogService: DialogService) {

	const actions: GridAction<VolunteerTopic>[] = [
		{
			iconClass: 'fa-regular fa-pen-to-square',
			label: 'Edit topic',
			isEnabled: rows => {
				if (!dialogDataService.hasVolunteerEditPermissions()) return false;
				if (!!rows.length && !!rows[0] && rows[0].volunteerId) {
					const statusId = dialogDataService.volunteerDetails()?.volunteerStatusId;
					if (statusId === VolunteerStatusId.Approved || statusId === VolunteerStatusId.ApprovedWithCaution) {
						return true;
					} else {
						dialogService.showMessage('Message', 'Volunteer topic can only be edited for approved volunteers.', 'Okay', [], 400, 200);
					}
				}
				return false;
			},
			execute: async (rows) => {
				const statusId = dialogDataService.volunteerDetails()?.volunteerStatusId;
				if (statusId === VolunteerStatusId.Approved || statusId === VolunteerStatusId.ApprovedWithCaution) {
					await dialogService.showCustom<VolunteerTopicsFormDialog, VolunteerTopicsFormDialogData>(VolunteerTopicsFormDialog, {
						data: {
							mode: DialogMode.EDIT,
							volunteerTopicId: rows[0]?.volunteerTopicId,
							volunteerId: rows[0]!.volunteerId, // Checked in isEnabled
							readonly: !dialogDataService.hasVolunteerEditPermissions(),
						}
					}, 500, 450);

					await dialogDataService.getVolunteerDetails(rows[0]!.volunteerId);
				} else {
					dialogService.showMessage('Message', 'Volunteer topic can only be edited for approved volunteers.', 'Okay', [], 400, 200);
				}
			}
		},
	];

	return actions;
}